import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {HashRouter} from 'react-router-dom';
import axios from 'axios';
import { Provider } from 'react-redux';
import store from './store/cds';
import setupGlobalLoading from './utils/setupGlobalLoading';


axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
axios.defaults.headers.common['Strict-Transport-Security'] = `max-age=15552000; includeSubDomains`;
axios.defaults.headers.common['X-Content-Type-Options'] = `nosniff`;
axios.defaults.headers.common['X-Frame-Options'] = `SAMEORIGIN`;
axios.defaults.headers.common['Referrer-Policy'] = `no-referrer`;
axios.defaults.headers.common['Content-Security-Policy'] = `default-src 'self';base-uri 'self';font-src 'self' https: data:;form-action 'self';frame-ancestors 'self';img-src 'self' data:;object-src 'none';script-src 'self';script-src-attr 'none';style-src 'self' https: 'unsafe-inline';upgrade-insecure-requests`;

setupGlobalLoading();





const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <BrowserRouter> */}
    <HashRouter>
      <Provider store={store}>
          <App/>
      </Provider>
    </HashRouter>
    {/* </BrowserRouter> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
